import './sentry';

import 'semantic-ui-css/semantic.min.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';

import { App } from '@/App';
import { store, persistor } from '@/store';
import '@/settings/i18n';
import { instance } from '@/services/api/axios/instance';
import { setUp } from '@/services/api/axios/interceptors';

// styles
import 'react-datepicker/dist/react-datepicker.css';
import '@/styles/common.css';
import '@/styles/index.css';

setUp(instance);

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Router>
              <App />
            </Router>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
